import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControlLabel, Switch, Typography, Box } from '@mui/material';

/**
 * Switch component that integrates with React Hook Form
 */
interface FormSwitchProps {
  name: string;
  label: string;
  description?: string;
  disabled?: boolean;
}

export const FormSwitch: React.FC<FormSwitchProps> = ({
  name,
  label,
  description,
  disabled = false,
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={
            <Switch
              checked={field.value ?? false}
              onChange={(e) => field.onChange(e.target.checked)}
              disabled={disabled}
              color="primary"
            />
          }
          label={
            description ? (
              <Box>
                <Typography variant="body1">{label}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {description}
                </Typography>
              </Box>
            ) : (
              label
            )
          }
        />
      )}
    />
  );
};

export default FormSwitch;